export const CHECKOUT_SHIPPING_FEE_NGN = 0;
export const CHECKOUT_TAX_RATE = 0.025;

export const CHECKOUT_VAT_PERCENT_LABEL = `${(CHECKOUT_TAX_RATE * 100).toFixed(1)}%`;
